import { render } from "./SConfirmSubmitPage.vue?vue&type=template&id=6d7fae88"
import script from "./SConfirmSubmitPage.vue?vue&type=script&lang=js"
export * from "./SConfirmSubmitPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__